<template>
  <b-row style="max-width:800px;margin:auto;padding:20px 10px">
    <b-col sm="12">
      <h6 class="showing-data__for">Submit Feedback</h6>
      <b-alert v-if="message" :show="true" :variant="message.type">{{ message.message }}</b-alert>
      <b-alert v-if="statusLoaded && !requestValid" show variant="warning">
        {{ statusReason || "This feedback request is no longer active." }}
      </b-alert>

      <b-card v-if="statusLoaded && requestValid">
        <FeedbackSubmitForm
          :request-id="requestId"
          :prefill-reviewer-name="prefillReviewerName"
          :prefill-reviewer-role="prefillReviewerRole"
          :requester-name="requesterName"
          @submitted="handleSubmitted"
        />
      </b-card>

      <div v-else-if="!statusLoaded" class="text-center my-4">
        <b-spinner small class="mr-2" />
        <span class="text-muted">Checking request status...</span>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import FeedbackSubmitForm from "@/components/entries/FeedbackSubmitForm.vue";

export default {
  name: "FeedbackSubmit",
  components: { FeedbackSubmitForm },
  data() {
    return {
      requestId: null,
      message: null,
      statusLoaded: false,
      requestValid: false,
      statusReason: "",
      prefillReviewerName: "",
      prefillReviewerRole: "",
      requesterName: "",
    };
  },
  methods: {
    handleSubmitted() {
      this.$router.push({ name: "feedback/thanks" });
    },
    checkStatus() {
      this.statusLoaded = false;

      return this.$api.v2
        .get(`entries/feedback/status?id=${encodeURIComponent(this.requestId)}`)
        .then((resp) => {
          const body = resp.body || {};
          this.requestValid = body.is_valid === true;
          this.statusReason = body.reason || "";
          this.prefillReviewerName = body.reviewer_name || "";
          this.prefillReviewerRole = body.reviewer_role || "";
          this.requesterName = body.requested_by_name || "";
        })
        .catch(() => {
          this.requestValid = false;
          this.statusReason = "This feedback request is invalid or no longer active.";
          this.prefillReviewerName = "";
          this.prefillReviewerRole = "";
          this.requesterName = "";
        })
        .finally(() => {
          this.statusLoaded = true;
        });
    },
  },
  created() {
    this.requestId = this.$route.params.id;
    this.checkStatus();
  },
};
</script>

<style scoped lang="scss">
.showing-data__for { font-weight: 600; margin-bottom: 8px; color: $blue-300; }
</style>
